import { randNumber, randBoolean, randPastDate, randFullName, randCatchPhrase } from '@ngneat/falso';

import { ReportListItem } from './report-list-item';

export class MockReportListItem extends ReportListItem {
   constructor() {
      super({
         id: randNumber({ max: 100 }),
         owner_name: randFullName(),
         last_updated: randPastDate().toISOString(),
         name: randCatchPhrase(),
         shared: randBoolean(),
         owned: randBoolean(),
         pinned: randBoolean(),
      });
   }
}
